export default "__VITE_ASSET__a92475fc__"